<template>
  <div class="col-12 connections py-4 mb-4">
    <div class="card">
      <div class="card-header">
        <h5 class="card-title mb-0">Связанные организации</h5>
      </div>
      <div class="card-body">
        <template v-if="connections?.length">
          <div class="filter-container d-flex align-items-center my-4">
            <label for="type-filter">Тип</label>
            <select id="type-filter" v-model="selectedType" class="form-select w-auto ms-4">
              <option value="Все">Все</option>
              <option value="Действует">Действующая</option>
              <option value="Ликвидирована">Ликвидирована</option>
              <option value="Не действует">Не действующая</option>
            </select>
          </div>
          <div class="connections-list-container">
            <div v-for="(company, index) in filteredOrganizations" :key="index" class="connections-list">
              <div class="connections-list__header">
                <h4>{{ company.name }}</h4>
                <span v-if="company.status" class="status" :class="getClass(company.status)">{{ company.status }}</span>
              </div>
              <div class="connections-list__body">
                <p v-if="company.relations?.length" class="relation">
                  <span>Связь:</span> {{ company.relations.join(', ') }}
                </p>
                <p v-if="company.related_people?.length" class="director">
                  <span>Через:</span> {{ formatPeople(company.related_people) }}
                </p>
                <p v-if="company.legal_address" class="address">
                  {{ company.legal_address }}
                </p>
                <p v-if="company.inn || company.ogrn || company.registration_date" class="details">
                  <template v-if="company.inn"><span>ИНН: </span>{{ company.inn }}</template>
                  <template v-if="company.ogrn"> | <span>ОГРН: </span>{{ company.ogrn }}</template>
                  <span v-if="company.registration_date">
                    | <span>Дата регистрации: </span>{{ formatDate(company.registration_date) }}
                  </span>
                </p>
                <p v-if="company.okved" class="activity">
                  <span>Основной вид деятельности:</span>
                  {{ company.okved_code ? company.okved_code + ' - ' : '' }}{{ company.okved }}
                </p>
              </div>
            </div>
          </div>
        </template>
        <template v-else><p class="text-center">Нет данных</p> </template>
      </div>
    </div>
  </div>
</template>
<script>
  import { defineComponent, ref, computed } from 'vue';
  import moment from 'moment';

  export default defineComponent({
    name: 'Connections',
    props: {
      connections: {
        type: Array,
        default: () => [],
      },
    },
    setup(props) {
      const selectedType = ref('Все');
      const filteredOrganizations = computed(() => {
        if (selectedType.value === 'Все') {
          return props.connections || [];
        } else if (selectedType.value === 'Действует' || selectedType.value === 'Не действует') {
          return (props.connections || []).filter((org) => org.status === selectedType.value);
        } else {
          return (props.connections || []).filter((org) => org.status !== 'Действует' && org.status !== 'Не действует');
        }
      });
      const getClass = (status) => {
        if (status === 'Действует') {
          return 'active';
        } else if (status === 'Не действует') {
          return 'inactive';
        } else {
          return 'liquidated';
        }
      };

      const formatDate = (date) => {
        return date ? moment(date).format('DD.MM.YYYY') : '-';
      };

      const formatPeople = (people) => {
        const unique = [];
        (people || []).forEach((person) => {
          const label = [person?.post, person?.fio].filter(Boolean).join(' - ');
          if (label && !unique.includes(label)) {
            unique.push(label);
          }
        });
        return unique.join('; ');
      };

      return {
        selectedType,
        filteredOrganizations,
        getClass,
        formatDate,
        formatPeople,
      };
    },
  });
</script>
